const getHeaderValue = (headers, name) => {
  if (!headers) {
    return '';
  }

  if (typeof headers.get === 'function') {
    return headers.get(name) || '';
  }

  return headers[name] || headers[name.toLowerCase()] || '';
};

const decodeHeaderFileName = (value) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const getFileNameFromHeaders = (headers, fallbackFileName) => {
  const contentDisposition = getHeaderValue(headers, 'content-disposition');

  if (contentDisposition) {
    const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      return decodeHeaderFileName(utf8Match[1]);
    }

    const asciiMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
    if (asciiMatch?.[1]) {
      return asciiMatch[1];
    }
  }

  return fallbackFileName;
};

const triggerFileDownload = (blob, fileName) => {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = fileName || 'download';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl);
  }, 60_000);
};

export const downloadBinaryFile = async (client, url, fallbackFileName = 'download') => {
  const response = await client.get(url, {
    responseType: 'blob',
    headers: {
      Accept: 'application/octet-stream'
    }
  });

  const fileName = getFileNameFromHeaders(response.headers, fallbackFileName);
  triggerFileDownload(response.data, fileName);

  return {
    fileName,
    contentType: getHeaderValue(response.headers, 'content-type')
  };
};
